<template>
    <div class="recordView">
        <DropdownMenu>
            <DropdownItem :title="form.beginDate ? getTimes(form.beginDate, 'YYYY-MM') : '选择时间'" ref="time">
                <DatetimePicker @cancel="cancel" @confirm="confirm" v-model="currentDate" cancel-button-text="清空"
                    type="year-month" />
            </DropdownItem>
            <List v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="getList">
                <div class="listItem" v-for="(item, index) in list" :key="index">
                    <p class="time van-hairline--bottom">{{ item.createTime }}</p>
                    <div class="listItemBottom">
                        <div class="listItemTitle">
                            <div class="statusTag" :class="recordType[item.status].className">{{
                                recordType[item.status].text }} </div>
                            <em> {{ item.amount }}元</em>
                        </div>
                        <div class="listInfo">
                            <span>订单号：{{ item.sn }}</span>
                            <div class="wechatPay">微信 </div>
                        </div>
                    </div>
                    <div class="auditRemark" v-if="item.auditRemark">备注：{{ item.auditRemark }}</div>
                </div>
            </List>
        </DropdownMenu>
    </div>
</template>
<script>
import { DropdownMenu, DropdownItem, DatetimePicker, List } from 'vant';
import { getWithdrawList } from '@/api/withdraw';
export default {
    name: "RecordList",
    components: {
        DropdownMenu,
        DropdownItem,
        DatetimePicker,
        List,
    },
    data() {
        return {
            form: {
                beginDate: '',
                endDate: '',
                page: 1
            },
            list: [],
            currentDate: new Date(),
            listLoading: false,
            finished: false,
            recordType: {
                'PENDING_AUDIT': {
                    text: '待审核',
                    className: 'pendingAudit',
                },
                'PENDING_PAYING': {
                    text: '提现中',
                    className: 'pendingPaying',
                },
                'SUCCESS': {
                    text: '成功',
                    className: 'success',
                },
                'FAIL': {
                    text: '失败',
                    className: 'fail',
                },
                'REFUSED': {
                    text: '拒绝',
                    className: 'refused',
                },
                'MANUAL_PAYMENT': {
                    text: '线下转账',
                    className: 'manualPayment',
                },
            },
        }
    },
    methods: {
        cancel() {
            this.form.page = 1;
            this.list = [];
            this.$refs.time.toggle();
            this.form.beginDate = '';
            this.form.endDate = '';

            this.currentDate = new Date();
            this.getList();
        },
        confirm(value) {
            const tempData = this.getTimes(value, 'YYYY-MM');
            this.form.beginDate = this.getMonthRange(tempData).start;
            this.form.endDate = this.getMonthRange(tempData).end;
            this.form.page = 1;
            this.$refs.time.toggle();
            this.list = [];
            this.getList();
        },
        getList() {
            this.listLoading = true;
            this.finished = false;
            getWithdrawList(this.form).then(res => {
                console.log("提现列表", res.records);
                this.list = [...this.list, ...res.records];
                this.listLoading = false;
                if (res.records.length < 10) {
                    // 数据全部加载完成
                    this.finished = true;
                    return;
                }
                this.form.page++;
            }).finally(() => {
                this.listLoading = false;
            })
        },
    }
}
</script>
<style lang='less' scoped>
.recordView {
    min-height: 100vh;
    background-color: #f7f7f7;

    .listItem {
        margin-top: 2.7vw;
        background-color: white;
        padding: 2vw 0vw;

        .time {
            height: 5.7vw;
            line-height: 5.7vw;
            text-indent: 5.2vw;
            font-size: 2.9vw;
            color: #999999;
        }

        .listItemBottom {
            padding: 2vw 5.2vw 0.5vw;
            margin-bottom: 2vw;

            .listItemTitle {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 10vw;

                .statusTag {
                    border-radius: 1vw;
                    font-size: 3.2vw;
                    padding: 1.5vw 2vw;
                }

                .pendingAudit {
                    background-color: #f4f4f5;
                    color: #909399;
                    border: 1px solid #e9e9eb;
                }

                .pendingPaying {
                    background-color: #fdf6ec;
                    color: #e6a23c;
                    border: 1px solid #faecd8;
                }

                .success {
                    background-color: #f0f9eb;
                    color: #67c23a;
                    border: 1px solid #e1f3d8;
                }

                .fail {
                    background-color: #fef0f0;
                    color: #f56c6c;
                    border: 1px solid #fee0e0;
                }

                .refused {
                    background-color: #fef0f0;
                    color: #f56c6c;
                    border: 1px solid #fee0e0;
                }

                .manualPayment {
                    background-color: #ecf5ff;
                    color: #409eff;
                    border: 1px solid #d9ecff;
                }

                span {
                    font-size: 3.7vw;
                    color: #333333;
                }

                em {
                    font-size: 5.3vw;
                    color: #fe8f51;
                }
            }

            .listInfo {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 5.5vw;
                font-size: 3.2vw;
                color: #a9a9a9;

                .wechatPay {
                    border-radius: 1vw;
                    font-size: 3.2vw;
                    padding: 1vw 1.2vw;
                    background-color: #67c23a;
                    color: #FFF;
                    border: 1px solid #67c23a;
                }
            }
        }

        .auditRemark {
            border-top: 1px solid #e9e9eb;
            padding: 2vw 5.2vw 0.5vw;
            font-size: 3.2vw;
            color: #999999;
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/page/mine/withdraw/recordList/recordList.vue